export enum CookieNames {
	VIEW_MODE = 'calendar-view-mode',
	PERSONALIZATION = 'MHA_PERSONALIZATION_2025',
	BREAKPOINT = 'breakpoint',
	FESTIVAL_DISPLAY = 'time'
}
